import React, { useEffect, useState } from "react";
import { Menu, X, Plane } from "lucide-react";
import { Button } from "@/components/ui/button";

const LINKS = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Packages", href: "#packages" },
  { label: "Services", href: "#services" },
  { label: "Gallery", href: "#gallery" },
  { label: "Testimonials", href: "#testimonials" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/95 backdrop-blur-xl border-b border-gray-200/60 shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between px-5 md:px-8 h-[72px]">
        <a
          href="#home"
          data-testid="navbar-logo"
          className="flex items-center gap-2 group"
          onClick={(e) => { e.preventDefault(); handleNav("#home"); }}
        >
          <span className="flex items-center justify-center w-10 h-10 rounded-xl bg-[#0B3D91] group-hover:rotate-6 transition-transform">
            <Plane className="w-5 h-5 text-[#F9B233]" strokeWidth={2.5} />
          </span>
          <span className={`text-xl font-bold tracking-tight ${scrolled ? "text-[#0B3D91]" : "text-white drop-shadow"}`}>
            Malviya <span className="text-[#F9B233]">Travel</span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              onClick={(e) => { e.preventDefault(); handleNav(l.href); }}
              className={`nav-link text-sm font-medium tracking-wide ${
                scrolled ? "text-[#222]" : "text-white/95"
              } hover:text-[#F9B233]`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:block">
          <Button
            data-testid="navbar-book-btn"
            onClick={() => handleNav("#contact")}
            className="bg-[#F9B233] hover:bg-[#e6a11f] text-[#0B3D91] font-semibold rounded-full px-6 h-11 shadow-md hover:shadow-lg hover:scale-[1.03] transition-all"
          >
            Book Now
          </Button>
        </div>

        <button
          data-testid="navbar-mobile-toggle"
          className={`lg:hidden p-2 rounded-lg ${scrolled ? "text-[#0B3D91]" : "text-white"}`}
          onClick={() => setOpen((o) => !o)}
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div data-testid="navbar-mobile-menu" className="lg:hidden bg-white border-t border-gray-100 px-5 py-4 shadow-lg">
          <div className="flex flex-col gap-3">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={(e) => { e.preventDefault(); handleNav(l.href); }}
                className="py-2 text-[#222] font-medium hover:text-[#F9B233]"
              >
                {l.label}
              </a>
            ))}
            <Button
              onClick={() => handleNav("#contact")}
              className="bg-[#F9B233] hover:bg-[#e6a11f] text-[#0B3D91] font-semibold rounded-full mt-2"
            >
              Book Now
            </Button>
          </div>
        </div>
      )}
    </header>
  );
}
